import { motion } from "framer-motion";
import { Star, BookOpen, Layers, Infinity as InfinityIcon } from "lucide-react";
import CountUp from "./CountUp";

const STATS = [
    {
        icon: BookOpen,
        node: <CountUp to={12000} suffix="+" />,
        label: "eBooks in the bundle",
    },
    {
        icon: Layers,
        node: <CountUp to={16} suffix="+" />,
        label: "Curated categories",
    },
    {
        icon: Star,
        node: "4.9/5",
        label: "Average reader rating",
    },
    {
        icon: InfinityIcon,
        node: "Lifetime",
        label: "Pay once, read forever",
    },
];

export default function SocialProof() {
    return (
        <section
            data-testid="social-proof-strip"
            className="border-y border-emerald-100 bg-white"
        >
            <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-12">
                <div className="grid grid-cols-2 gap-8 lg:grid-cols-4">
                    {STATS.map(({ icon: Icon, node, label }, i) => (
                        <motion.div
                            key={label}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.4 }}
                            transition={{ duration: 0.55, delay: i * 0.08 }}
                            className="flex flex-col items-center gap-2 text-center"
                        >
                            <span className="flex items-center gap-2 font-display text-2xl font-extrabold text-slate-900 sm:text-3xl">
                                <Icon size={20} className="text-emerald-600" />
                                {node}
                            </span>
                            <span className="text-xs font-medium text-slate-500 sm:text-sm">
                                {label}
                            </span>
                        </motion.div>
                    ))}
                </div>
                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.3 }}
                    className="mt-8 flex flex-wrap items-center justify-center gap-2 text-center text-sm text-slate-600"
                >
                    <span className="flex text-amber-400">
                        {Array.from({ length: 5 }).map((_, i) => (
                            <Star
                                key={i}
                                size={15}
                                fill="currentColor"
                                strokeWidth={0}
                            />
                        ))}
                    </span>
                    <span className="font-semibold text-slate-800">
                        5,000+ happy readers
                    </span>{" "}
                    across India have already unlocked the library.
                </motion.p>
            </div>
        </section>
    );
}
